import React from 'react';
import { useTranslation } from 'react-i18next';
import AutocompleteFilter, { FilterOption } from '../../transactions/filters/AutocompleteFilter';

interface SmartCheckAssetFilterProps {
    assets: Array<{ asset: string; count: number }>;
    value: string[];
    onChange: (value: string[]) => void;
}

const SmartCheckAssetFilter: React.FC<SmartCheckAssetFilterProps> = ({ assets, value, onChange }) => {
    const { t } = useTranslation();

    const options: FilterOption[] = assets.map(({ asset, count }) => ({
        id: asset,
        label: `${asset} (${count})`,
    }));

    return (
        <AutocompleteFilter
            options={options}
            value={value}
            onChange={onChange}
            label={t('smartCheck.table.asset', 'Asset')}
            placeholder={t('smartCheck.table.asset', 'Asset')}
            sx={{ maxWidth: '250px', minWidth: '200px' }}
        />
    );
};

export default SmartCheckAssetFilter;
